import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // This imports your application's base CSS
import App from './App'; // This imports your main React App component

// If you have reportWebVitals, you can re-add it if needed, but it's optional
// import reportWebVitals from './reportWebVitals';

// Create a root for your React application to render into
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render your main App component into the root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you re-added reportWebVitals, call it here:
// reportWebVitals();
